import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import LoginPage from "./components/LoginPage";
import AdminDashboard from "./components/AdminDashboard";
import AddCustomer from "./components/AddCustomer";
import AccessUrlPage from "./components/AccessUrlPage";

const App: React.FC = () => {
  const role = localStorage.getItem("userRole"); // Get stored role

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />

        {/* <Route
          path="/dashboard"
          element={
            role === "customer" ? <Dashboard /> : <Navigate to="/" replace />
          }
        /> */}

        <Route
          path="/dashboard"
          element={
            (role === "super_admin" || role === "customer") ? <AdminDashboard /> : <Navigate to="/" replace />
          }
        />

        <Route
          path="/add-customer"
          element={
            role === "super_admin" ? <AddCustomer /> : <Navigate to="/" replace />
          }
        />

        <Route
          path="/access-url"
          element={
            role === "super_admin" ? <AccessUrlPage /> : <Navigate to="/" replace />
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
